import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import DeleteModal from "../../../components/Common/DeleteModal";
import { Link } from "react-router-dom"
import { map } from "lodash"
import classnames from "classnames"
import {
  getProjectUUIDAction, addProjectCampLead, getProjectCampLead, deleteProjectCampLead, sendProjectLeadWorksheet, getProjectSettingWorksheet, getAllProjectOpenHouse, addProjectOpenHouse, deleteProjectOpenHouse, updateProjectOpenHouse,
  getProjectWorksheetLead, getProjectWorksheetLeadPurDetail, getProjectWorksheetLeadUnitDetail,
  getProjectWorksheetLeadDocDetail, getProjectWorksheetUnitinfo


} from "../../../store/projects/actions"
import {
  addLeadNoteTab, getNoteLeadTab, addFollowNoteTab, getFollowLeadTab,
  getLeadCallLog, addLeadCallLog, addLeadEmailLog, getLeadEmailLog, getAllActLeadTab
} from "../../../store/leads/actions"
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import MaskedInput from "react-text-mask";
import Flatpickr from "react-flatpickr"
import Moment from 'react-moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import notes from "../../../assets/images/rsicons/notes.png";
import follow from "../../../assets/images/rsicons/follow-up.png";
import phonelog from "../../../assets/images/rsicons/phone-log.png";
import emaillog from "../../../assets/images/rsicons/email-log.png";
import { API_URL } from 'helpers/app_url';
import axios from "axios"
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Modal,
  Badge,
  ModalHeader,
  ModalBody,
  Input,
  Button,

  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Tooltip
} from "reactstrap"
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import RsLink from "components/buttons/rsLink";
import SafeField from "helpers/SafeField";
class projectTransferred extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lead: {},
      activeTab: "2",
      verticalActiveTab: "1",
      page: 1,
      sizePerPage: 10,
      viewmodal: false,
      modal: false,
      visible: false,
      modal_standard: false,
      isEditOpenHouse: false,
      isEditOpenHouseData: {},
      isWorkSheet: false,
      camplead: '',
      forId: '',
      activeTab1: "1",
      activeTab2: "4",
      selectedWorksheet: [],
      selectAll: false,
      agents: [],
      selectedValues: [],
      alllists: [],
      projectTransLead: [],
      isTransferLead: false,
      workSheetLeadData: [],
      recordId: 0,
      checkboxes: props.campleads.reduce(
        (options, item) => ({
          ...options,
          [item.id]: false,
        }),
        {}
      ),

      selectedCheckboxes: {},
      reports: [
        { title: "Email Sent", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "# Prospects",
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "# SRR",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "# Clients",
          iconClass: "bx-purchase-tag-alt",
          description: "2",
        },
      ]
    }

    this.tog_standard = this.tog_standard.bind(this)
    this.onClickDeleteLead = this.onClickDeleteLead.bind(this);

    this.toggleSubmittedCanvas = this.toggleSubmittedCanvas.bind(this);
    this.toggleEmailCanvas = this.toggleEmailCanvas.bind(this);
    this.toggleFollowCanvas = this.toggleFollowCanvas.bind(this);
    this.toggleCallLogCanvas = this.toggleCallLogCanvas.bind(this);
    this.toggleEmailLogCanvas = this.toggleEmailLogCanvas.bind(this);
    this.toggleSmsLogCanvas = this.toggleSmsLogCanvas.bind(this);
    this.toggleAddNoteCanvas = this.toggleAddNoteCanvas.bind(this);
    this.toggleMessageCanvas = this.toggleMessageCanvas.bind(this);
    this.toggleAddLeadCanvas = this.toggleAddLeadCanvas.bind(this);
    this.toggleOpenHouseCanvas = this.toggleOpenHouseCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.handleProjectCampLeadSubmit = this.handleProjectCampLeadSubmit.bind(this)
    this.toggleSendWorksheet = this.toggleSendWorksheet.bind(this);
    this.addOpenHouseData = this.addOpenHouseData.bind(this);
    this.updateOpenHouseData = this.updateOpenHouseData.bind(this);
    this.deleteOpenHouseData = this.deleteOpenHouseData.bind(this);
    this.handleAnchorClick = this.handleAnchorClick.bind(this);
    this.toggleTransferLead = this.toggleTransferLead.bind(this);
    //this.handleLeadNoteSubmit = this.handleLeadNoteSubmit.bind(this)
    this.toggle2 = this.toggle2.bind(this);
    this.toggle1 = this.toggle1.bind(this);
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };

  toggleTransferLead() {
    this.setState({ isTransferLead: !this.state.isTransferLead });
  }


  getCampaignLeadStatus = (a) => {
    if (a == 0)
      return "Not Send";
    else if (a == 1)
      return "Sent";
    else if (a == 2)
      return "Worksheet Submitted";
  };
  toggleAddLead() {
    this.setState(prevState => ({
      isAddLead: !prevState.isAddLead
    }));

  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }
  toggleFollow() {
    this.setState(prevState => ({
      isFollow: !prevState.isFollow
    }));

  }
  toggleAddNote() {
    this.setState(prevState => ({
      isAddNote: !prevState.isAddNote
    }));

  }
  toggleCallLog() {
    this.setState(prevState => ({
      isCallLog: !prevState.isCallLog
    }));

  }
  toggleWorkSheet() {
    this.setState({ isWorkSheet: !this.state.isWorkSheet });
  }
  toggleEmailLog() {
    this.setState(prevState => ({
      isEmailLog: !prevState.isEmailLog
    }));

  }
  toggleSmsLog() {
    this.setState(prevState => ({
      isSmsLog: !prevState.isSmsLog
    }));
  }
  toggleEmailCanvasLog() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }

  toggleEmailCanvas() {
    this.setState({ lead: "", isEdit: false, isRight: !this.state.isRight });
    this.toggleEmailCanvasLog();
  }
  toggleAddNoteCanvas() {
    this.setState({ lead: "", isEdit: false, isFollow: !this.state.isAddNote });
    this.toggleAddNote();
  }
  toggleMessageCanvas() {
    this.setState({ lead: "", isEdit: false, isMessage: !this.state.isMessage });
    //this.toggleAddNote();
  }
  toggleFollowCanvas() {
    this.setState({ lead: "", isEdit: false, isFollow: !this.state.isFollow });
    this.toggleFollow();
  }

  toggleCallLogCanvas() {
    this.setState({ lead: "", isEdit: false, isCallLog: !this.state.isCallLog });
    this.toggleCallLog();
  }

  toggleEmailLogCanvas() {
    this.setState({ lead: "", isEdit: false, isEmailLog: !this.state.isEmailLog });
    this.toggleEmailLog();
  }
  toggleSmsLogCanvas() {
    this.setState({ lead: "", isEdit: false, isSmsLog: !this.state.isSmsLog });
    this.toggleSmsLog();
  }
  toggleOpenHouseCanvas() {
    this.setState({ isEditOpenHouseData: {}, isEditOpenHouse: !this.state.isEditOpenHouse });
    //this.toggleOpenHouse();
  }

  toggleOpenHouseCanvas = arg => {
    this.setState({ isEditOpenHouseData: arg });
    // onGetNoteLead(camplead.leadId);
    //this.toggleOpenHouse();
  };

  toggleAddNoteCanvas() {
    this.setState({ camplead: "", isEdit: false, isAddNote: !this.state.isAddNote });
    this.toggleAddNote();
  }


  toggleFollowCanvas = arg => {
    const clead = arg;
    const { onGetFollowLead } = this.props;
    this.setState({
      lead: {
        leadId: clead.leadId,
      },
      isEditFollow: true,
    });
    onGetFollowLead(clead.leadId);
    this.toggleFollow();
  };
  toggleAddNoteCanvas = arg => {
    const lead = arg;
    const { onGetNoteLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEdit: true,
    });
    onGetNoteLead(lead.leadId);
    this.toggleAddNote();
  };

  toggleCallLogCanvas = arg => {
    const lead = arg;
    const { onGetLeadCallLog } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },

    });
    onGetLeadCallLog(lead.leadId);
    this.toggleCallLog();
  };
  toggleEmailLogCanvas = arg => {
    const lead = arg;
    const { onGetLeadEmailLog } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEditCall: true,
    });
    onGetLeadEmailLog(lead.leadId);
    this.toggleEmailLog();
  };
  toggleSmsLogCanvas = arg => {
    const lead = arg;
    this.setState({
      lead: {
        leadId: lead.id
      },


    });
    this.toggleSmsLog();
  };
  toggleAddLeadCanvas() {
    this.setState({ isAddLead: !this.state.isAddLead });
    //this.toggleAddLead();
  }


  toggle2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }
  toggleSendWorksheet() {
    this.setState({ camplead: "", isSendWorksheetEmail: false, isWorkSheet: !this.state.isWorkSheet });
    this.toggleWorkSheet();
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  tog_standard() {
    this.setState(prevState => ({
      modal_standard: !prevState.modal_standard,
    }))
    this.removeBodyCss()
  }

  removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  handleProjectCampLeadSubmit(value) {
    //
    this.props.addProjectCampLead(value, this.props.history);
    this.toggleAddLead();
  }
  componentDidMount() {
    const { match: { params }, ongetProjectUUIDAction, onGetProjectCampLead, onGetNoteLead, onGetProjectSettingWorksheet, onGetAllProjectOpenHouse } = this.props;
    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectCampLead(localStorage.getItem('userId'), params.projectId);
      onGetProjectSettingWorksheet(params.projectId)
      onGetAllProjectOpenHouse(localStorage.getItem('userId'), params.projectId);
    }

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}ProjectCampaignLead/allforbrokerproject`, {
      params: {
        brokerId: localStorage.getItem("userId"),
        projectId: params.projectId,
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ projectTransLead: res.data });
      })

    axios.get(`${API_URL}AgentExt/AllAgentByOffice`, {
      params: {
        clientId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ agents: res.data });
      })
    //
  }


  toggleDeleteLeadModal = () => {
    this.setState(prevState => ({
      deleteLeadModal: !prevState.deleteLeadModal,
    }));
  };

  onClickDeleteLead = (camplead) => {
    this.setState({ camplead: camplead });
    this.setState({ deleteLeadModal: true });
  };


  handleDeleteCampLeqad = () => {
    const { onDeleteCampLead } = this.props;
    const { camplead } = this.state;
    //
    if (camplead.id !== undefined) {
      onDeleteCampLead(camplead.id);
      this.setState({ deleteLeadModal: false });
    }
  };

  toggleEmailCanvas = arg => {
    const lead = arg;
    const { onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
      },
      isEdit: true,
    });
    onGetAllActLead(lead.leadId)
    this.toggleEmailCanvasLog();
  };


  addOpenHouseData(values) {
    //

    this.props.addProjectOpenHouse(values);
  }

  updateOpenHouseData(values) {
    this.props.updateProjectOpenHouse(values);
  }

  deleteOpenHouseData(data) {

    this.props.deleteProjectOpenHouse(data);
  }

  handleAnchorViewClick(e, value) {
    this.toggleTransferLead();    
    this.setState({ agnetIdN: value.agentId , lead : value,recordId: value.leadId });
  };


  handleAnchorClick(e, value) {
    this.toggleTransferLead();
    this.setState({ recordId: value });
  };

  handleSelectAll = () => {
    const { selectAll, checkboxes } = this.state;
    const newSelectAll = !selectAll;
    const newCheckboxes = {};

    map(this.props.allProjectOpenHouseData, (data) => {
      newCheckboxes[data.id] = newSelectAll;
    });

    this.setState({
      selectAll: newSelectAll,
      checkboxes: newCheckboxes
    });
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const { checkboxes } = this.state;

    const newCheckboxes = {
      ...checkboxes,
      [name]: checked
    };

    const allChecked = Object.values(newCheckboxes).every(Boolean);

    this.setState({
      checkboxes: newCheckboxes,
      selectAll: allChecked
    });
  };
  toggleSendWorksheet = arg => {
    const camplead = arg;
    const listItems = [];
    const { checkboxes } = this.state;
    const allLeads = Object.keys(checkboxes)
      .filter((key) => checkboxes[key])
      .map((key) => this.props.campleads.find((option) => option.id == key));
    const leadIds = allLeads.map(lead => lead.id);
    const commaSeparatedLeadIds = leadIds.join(',');
    //

    this.setState({
      camplead: {
        leadId: camplead.leadId,
        alllists: commaSeparatedLeadIds
      },
      isSendWorksheetEmail: true,
    });
    this.toggleWorkSheet();
  };
  toggleSubmit() {

    this.setState({ isSubmittedData: !this.state.isSubmittedData });

  }
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }
  toggleSubmittedCanvas() {
    this.setState({ worksheetLead: '', isSubmittedData: !this.state.isSubmittedData });
    this.toggleSubmit();
  }

  toggleSubmittedCanvas = arg => {
    const worksheetLead = arg;
    const { onGetProjectWorksheetLeadPurDetail, onGetProjectWorksheetLeadUnitDetail, onGetProjectWorksheetLeadDocDetail, onGetProjectWorksheetUnitinfo } = this.props;
    this.setState({
      worksheetLead: {
        id: worksheetLead.id,
        unitStatusId: worksheetLead.unitStatusId,
      }
    });
    //
    onGetProjectWorksheetLeadPurDetail(worksheetLead.workSheetId);
    onGetProjectWorksheetLeadUnitDetail(worksheetLead.workSheetId);
    onGetProjectWorksheetLeadDocDetail(worksheetLead.workSheetId);
    onGetProjectWorksheetUnitinfo(worksheetLead.workSheetId)
    this.toggleSubmit();
  };
  render() {
    const phoneNumberMask = [
      "(",
      /[1-9]/,
      /\d/,
      /\d/,
      ")",
      " ",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ];
    const { projectData, onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog, onSendWorksheetEmailLog, worksheets, allProjectOpenHouseData, worksheetPurData, worksheetUnitData, worksheetDocData } = this.props;
    const { leadNotes, leadFollows, calllogs, emaillogs, activities } = this.props;
    const { campleads } = this.props;
    const { projectTransLead, deleteLeadModal, forId } = this.state;
    const { isEdit, isEditFollow, isEditCall, isEditEmail, isSendWorksheetEmail } = this.state;
    const lead = this.state.lead;
    const camplead = this.state.camplead;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { selectAll, checkboxes, selectedValues } = this.state;
    const isAnyTrue = Object.values(checkboxes);
    const trueCount = isAnyTrue.filter((value) => value === true).length;
    //
    //
    const userData = JSON.parse(localStorage.getItem("authUser"));
    const agentEMail = userData.resultData.userName;
    
    const { agents } = this.state;    
    
    const updatedList = agents.filter(item => item.id !== lead.agentId);

    //
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteLeadModal}
          onDeleteClick={this.handleDeleteCampLeqad}
          onCloseClick={() => this.setState({ deleteLeadModal: false })}
        />
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Activity")} />
                  </Col>
                  <Col sm="4">
                    <h2 className="">{this.props.t(projectData.projectName)}</h2>
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <Nav tabs className="projectTab projectNav">

                      <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/current-prospects/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">Office Leads</span>

                        </Link>
                      </NavItem>
                      <NavItem>

                        <Link className="nav-link active" to={"/pre-construction/campaign/transferred/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">Transferred Lead</span>

                        </Link>
                      </NavItem>


                      <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/srr-filled/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Worksheets")}</span>

                        </Link>
                      </NavItem>

                      <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/client/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Clients")}</span>

                        </Link>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        {trueCount > 0 &&
                          <Row>
                            <Nav tabs className="projectTab popup-nav">
                              <NavItem>
                                <Link className="nav-link "

                                >
                                  <span className="d-none d-sm-block">{trueCount} Selected</span>

                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link className="nav-link "

                                >
                                  <span className="d-none d-sm-block">{this.props.t("Send Message")}</span>

                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link className="nav-link "
                                  onClick={this.toggleSendWorksheet}
                                >
                                  <span className="d-none d-sm-block">{this.props.t("Send Worksheets")}</span>

                                </Link>
                              </NavItem>
                            </Nav>

                          </Row>}



                        <div className="table-rep-plugin">
                          <div
                            className=" mb-0"
                            data-pattern="priority-columns"
                          >
                            <Table
                              id="tech-companies-1"
                              className="table table-striped table-bordered"
                            >
                              <Thead>
                                <Tr>
                                  <Th>{this.props.t("Agent Name")}</Th>
                                  <Th>{this.props.t("Name")}</Th>
                                  <Th data-priority="1">{this.props.t("Transferred Date")}</Th>
                                  <Th data-priority="3">{this.props.t("Email")}</Th>
                                  <Th data-priority="3">{this.props.t("Phone")}</Th>
                                  {/* <Th data-priority="3">{this.props.t("Source")}</Th> */}
                                  <Th data-priority="3">{this.props.t("Worksheet")}</Th>
                                  <Th data-priority="3">{this.props.t("Action")}</Th>

                                </Tr>
                              </Thead>
                              <Tbody className="tbody">

                                {map(projectTransLead, (data, prokey) => (
                                  <Tr>
                                    <Td> {data.isTransferLead ? "Self" : data.agentName}
                                      <div style={{ fontSize: '8px' }}>{data.leadSourceId ? localization["LeadSource_" + data.leadSourceId] : 'Manual'}</div>
                                    </Td>

                                    <Td className="table-data">
                                      <div className="row">
                                        <div className="col-sm-8" >{data.firstName} {data.lastName}</div>
                                        <div className="col-sm-1"><Link onClick={() => this.toggleEmailCanvas(data)} to="#"><i className="grid-icon bx  bx-timer"></i></Link></div>
                                      </div>
                                    </Td>

                                    <Td> <Moment format="D-MMM-YYYY">{data.transferredDate}</Moment>  </Td>
                                    <Td>  {data.email}  </Td>

                                    {/* <Td>       </Td> */}
                                    <Td>      {data.mobile}   </Td>
                                    {/* <Td>{data.leadSourceId ? localization["LeadSource_" + data.leadSourceId] : 'Manual'}</Td> */}
                                    <Td>{this.getCampaignLeadStatus(data.campaignLeadStatus)}</Td>
                                    <Td>
                                      {data.campaignLeadStatus > 0 && (
                                        <a href="#" onClick={() => this.toggleSubmittedCanvas(data)}>
                                          View
                                        </a>
                                      )}
                                      {data.campaignLeadStatus == 0 && (
                                        <a href="#" onClick={(e) => this.handleAnchorViewClick(e, data)}>
                                          Re-Assign
                                        </a>
                                      )}
                                    </Td>

                                  </Tr>
                                ))}

                              </Tbody>
                            </Table>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>

                </Row>
              </Col>
            </Row>
          </Container>
        </div >



        <Offcanvas
          isOpen={this.state.isTransferLead}
          direction="end"
          toggle={this.toggleTransferLead}
        >
          <OffcanvasHeader toggle={this.toggleTransferLead}>
            Re-Transfer Lead
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "1",
                  })}
                  onClick={() => {
                    this.toggle1("1");
                  }}
                >
                  <i className="grid-icon  bx bx-message-alt grid-iconSize"><span className="tabSelected"> Assigned Agent</span></i>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "2",
                  })}
                  onClick={() => {
                    this.toggle1("2");
                  }}
                >
                  <i className="grid-icon  bx bx-user-voice grid-iconSize"><span className="tabSelected"> Assign New Agent</span></i>

                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={this.state.activeTab1}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: this.state.agnetIdN
                    }}

                    onSubmit={values => {


                    }}
                  >
                    {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentId">
                                Agent Name
                              </Label>
                              <SafeField as="select" disabled name="agentId"
                                className={
                                  "form-control" +
                                  (errors.agentId && touched.agentId
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={handleChange}>
                                <option value="">Select</option>
                                {
                                  this.state.agents                                  
                                    .map(agents =>
                                      <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                                    )
                                }
                              </SafeField>
                              <ErrorMessage
                                name="agentId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>

                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: ''
                    }}
                    validationSchema={Yup.object().shape({
                      agentId: Yup.string().required("This is required"),
                    })}

                    onSubmit={values => {

                      //const firstTrueValue = Object.entries(checkboxes).find(([key, value]) => value === true);

                      const obj = JSON.parse(localStorage.getItem("authUser"));
                      const token = obj.resultData.bearerToken;
                      const str = 'Bearer ' + token;

                      const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': str
                      };

                      var id = parseInt(lead.id);
                      var brokerId = parseInt(localStorage.getItem("userId"));
                      var agentId = parseInt(values.agentId);
                      var projectGuid = this.props.match.params.projectId;

                      const body = {
                        id,
                        brokerId,
                        agentId,
                        projectGuid
                      }

                      try {
                        this.toggleTransferLead();
                        toast.loading("Please wait...");
                        axios.put(`${API_URL}ProjectCampaignLead/UpdateProjectCampaignLeadTransfer`, body, { headers })
                          .then(response => {
                            toast.dismiss();
                            toast.success("Lead Transferred Successfully!");
                            //allProjectOpenHouseData(localStorage.getItem('userId'), this.props.match.params.projectId);
                            //location.reload();
                          })
                          .catch(error => {
                            toast.dismiss();
                            toast.success("Err :" + error);
                          });
                      } catch (error) {
                        toast.dismiss();
                        toast.success("Err :" + error);
                      }
                    }}
                  >
                    {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >
                        <Row>

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="agentId">
                                Agent Name
                              </Label>
                              <SafeField as="select" name="agentId"
                                className={
                                  "form-control" +
                                  (errors.agentId && touched.agentId
                                    ? " is-invalid"
                                    : "")
                                }
                                onChange={handleChange}>
                                <option value="">Select</option>
                                {
                                  updatedList
                                    .map(agents =>
                                      <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                                    )
                                }
                              </SafeField>
                              <ErrorMessage
                                name="agentId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Transfer</button></div>

                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>

            </TabContent>

          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isRight}
          direction="end"
          toggle={this.toggleEmailCanvas}
        >
          <OffcanvasHeader toggle={this.toggleEmailCanvas}>
            All Activities
          </OffcanvasHeader>
          <OffcanvasBody>
            <ul className="verti-timeline list-unstyled">
              {map(
                activities,
                (allactivity, allactkey) => (
                  <li
                    className="event-list eventlist"
                    key={"_allact_" + allactkey}
                  >
                    <div className="event-timeline-dot">
                      {(() => {
                        if (
                          allactivity.activitySubType ==
                          8 ||
                          allactivity.activitySubType ==
                          9 ||
                          allactivity.activitySubType ==
                          7
                        ) {
                          return (
                            <>
                              <img src={emaillog} />
                            </>
                          );
                        } else if (
                          allactivity.activitySubType ==
                          3 ||
                          allactivity.activitySubType ==
                          4 ||
                          allactivity.activitySubType ==
                          5
                        ) {
                          return (
                            <>
                              <img src={phonelog} />
                            </>
                          );
                        } else if (
                          allactivity.activitySubType ==
                          10
                        ) {
                          return (
                            <>
                              <img src={follow} />
                            </>
                          );
                        } else {
                          return (
                            <>
                              <img src={notes} />
                            </>
                          );
                        }
                      })()}
                    </div>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <h5 className="font-size-14">
                          <Moment format="D-MMM-YYYY">
                            {allactivity.addedDate}
                          </Moment>
                        </h5>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="font-size-14">
                          {
                            localization[
                            "ActivitySubType_" +
                            allactivity.activityType +
                            "_" +
                            allactivity.activitySubType
                            ]
                          }
                        </h5>
                      </div>
                    </div>
                    <div className="exNote">
                      {allactivity.activityRemarks}
                    </div>
                  </li>
                )
              )}
            </ul>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isEditOpenHouse}
          direction="end"
          toggle={this.toggleOpenHouseCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleOpenHouseCanvas}>
            {/* {this.state.isEditOpenHouseData.name} */}
            Add/Edit Lead Data
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                id: this.state.isEditOpenHouseData.id ?? "",
                projectOpenHouseId: this.state.isEditOpenHouseData.projectOpenHouseId ?? "",
                agentId: this.state.isEditOpenHouseData.agentId ?? projectData.agentId,
                projectId: this.state.isEditOpenHouseData.projectId ?? projectData.id,
                name: this.state.isEditOpenHouseData.name ?? "",
                mobileNo: this.state.isEditOpenHouseData.mobileNo ?? "",
                email: this.state.isEditOpenHouseData.email ?? '',
                withAgent: this.state.isEditOpenHouseData.withAgent ?? '',
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("This is Required"),
                email: Yup.string().required("This is Required"),

                // mlsurl: Yup.string().required("This is Required")
              })}

              onSubmit={values => {
                this.state.isEditOpenHouseData.agentId ? this.updateOpenHouseData(values) : this.addOpenHouseData(values);
                // 
                // this.submitFormData(values);
              }
              }

            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="name">
                              {this.props.t(" Name*")}
                            </Label>
                            <SafeField
                              name="name"
                              type="text"
                              className={
                                "form-control" +
                                (errors.name && touched.name
                                  ? " is-invalid"
                                  : "")
                              }
                              id="name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">

                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="email">
                              {this.props.t("Email*")}
                            </Label>
                            <SafeField
                              name="email"
                              type="email"
                              className={
                                "form-control" +
                                (errors.email && touched.email
                                  ? " is-invalid"
                                  : "")
                              }
                              id="email"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="mobileNo">
                              {this.props.t("Phone")}
                            </Label>
                            <SafeField
                              name="mobileNo"
                              type="text"
                              className={
                                "form-control" +
                                (errors.mobileNo && touched.mobileNo
                                  ? " is-invalid"
                                  : "")
                              }
                              id="mobileNo"
                            />
                            <ErrorMessage
                              name="mobileNo"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>



                        {/* <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="endDate">
                              {this.props.t("End Date")}
                            </Label>
                             <InputGroup>
                             <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.endDate && touched.endDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                   
                                    onChange={(value) => setFieldValue('endDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                        </InputGroup>
                          </FormGroup>
                        </Col> */}
                        <Col sm="12">
                          <hr></hr>
                        </Col>
                        {/* <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="isClient">
                                    {this.props.t("Are you currently working with an Agent? ")}
                                  </Label>
                                  <div className="clearfix"></div>
                                  <div className="form-check form-check-inline">
                                    <SafeField
                                      type="radio"
                                      id="customRadioInline1"
                                      name="withAgent"
                                      className="form-check-input"
                                      value="Yes"
                                    />
                                    <label className="form-check-label" htmlFor="customRadioInline1">
                                      Yes
                                    </label>
                                  </div>
                                  &nbsp;
                                  <div className="form-check form-check-inline">
                                    <SafeField
                                      type="radio"
                                      id="customRadioInline2"
                                      name="withAgent"
                                      className="form-check-input"
                                      value="No"
                                    />
                                    <label className="form-check-label" htmlFor="customRadioInline2">
                                      No
                                    </label>
                                  </div>
                            
                                </FormGroup>
                              </Col> */}


                        <Col sm="12">
                          <button type="submit" className="btn btn-primary w-md float-end mt-27">Submit</button>
                        </Col>

                      </Row>

                    </CardBody>
                  </Card>

                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isAddNote}
          direction="end"
          toggle={this.toggleAddNoteCanvas}
        >
          <OffcanvasHeader toggle={this.toggleAddNoteCanvas}>
            Add Notes
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{

                refId: lead.leadId,
                addNote: (this.state && this.state.addNote) || "",



              }}
              validationSchema={Yup.object().shape({
                addNote: Yup.string().required("This is Required")
              })}

              onSubmit={values => {

                if (isEdit) {

                  onAddLeadNote(values)
                  //onAddLeadNote(updateData);
                } else {

                }
                this.toggleAddNote();
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addNote">
                          {this.props.t("Add Note")}
                        </Label>
                        <textarea
                          name="addNote"
                          onChange={handleChange}
                          type="textarea"
                          className={
                            "form-control" +
                            (errors.addNote && touched.addNote
                              ? " is-invalid"
                              : "")
                          }
                          id="addNote"
                        />
                        <ErrorMessage
                          name="addNote"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Notes History</div>
            <ul className="verti-timeline list-unstyled">

              {map(leadNotes, (noteLog, notekey) => (

                <li className="event-list eventlist" key={"_note_" + notekey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D-MMM-YYYY">{noteLog.addedDate}</Moment>


                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14"></h5>
                    </div>
                  </div>
                  <div className="exNote">{noteLog.activityRemarks}</div>
                </li>
              ))}

            </ul>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isCallLog}
          direction="end"
          toggle={this.toggleCallLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleCallLogCanvas}>
            Call Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                actionType: '',
                addedDate: new Date(),
                refId: lead.leadId


              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {

                if (isEditCall) {

                  onAddCallLog(values)
                  //onAddLeadNote(updateData);
                } else {

                }
                this.toggleCallLog();
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" onChange={handleChange} />
                          No Answer
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" onChange={handleChange} />
                          Left Voicemail
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" onChange={handleChange} />
                          Bad Number
                        </label>

                      </div>
                      <ErrorMessage
                        name="actionType"
                        component="div"
                        className="invalid-feedback"
                      />

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addedDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.addedDate && touched.addedDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.addedDate}
                          onChange={(value) => setFieldValue('addedDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="addedDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="callNote">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="callNote"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="callNote"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Call Log History</div>
            <ul className="verti-timeline list-unstyled">

              {map(calllogs, (callLog, callkey) => (

                <li className="event-list eventlist" key={"_call_" + callkey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D-MMM-YYYY">{callLog.addedDate}</Moment>

                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                    </div>
                  </div>
                  <div className="exNote">{callLog.activityRemarks}</div>
                </li>
              ))}

            </ul>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isFollow}
          direction="end"
          toggle={this.toggleFollowCanvas}

        >
          <OffcanvasHeader toggle={this.toggleFollowCanvas}>
            Follow Us
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                refId: lead.leadId,
                addNote: (this.state && this.state.addNote) || "",
                nextFollowupDate: new Date(),


              }}
              validationSchema={Yup.object().shape({
                addNote: Yup.string().required("This is Required")
              })}

              onSubmit={values => {

                if (isEditFollow) {
                  //
                  onAddLeadFollowUp(values)
                  //onAddLeadNote(updateData);
                } else {

                }
                this.toggleFollow();
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">

                        <textarea
                          name="addNote"
                          onChange={handleChange}
                          type="textarea"
                          className={
                            "form-control" +
                            (errors.addNote && touched.addNote
                              ? " is-invalid"
                              : "")
                          }
                          id="addNote"
                        />
                        <ErrorMessage
                          name="addNote"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup className="mb15">

                        <Label htmlFor="logDate">
                          Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.nextFollowupDate && touched.nextFollowupDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.nextFollowupDate}
                          onChange={(value) => setFieldValue('nextFollowupDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="logDate"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col>
                  </Row>

                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
            <ul className="verti-timeline list-unstyled">

              {map(leadFollows, (follLog, follLogkey) => (

                <li className="event-list eventlist" key={"_note_" + follLogkey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D-MMM-YYYY">{follLog.activityRefStartDate}</Moment>


                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14"></h5>
                    </div>
                  </div>
                  <div className="exNote">{follLog.activityRemarks}</div>
                </li>
              ))}

            </ul>

          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isEmailLog}
          direction="end"
          toggle={this.toggleEmailLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleEmailLogCanvas}>
            Email Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                actionType: '',
                addedDate: new Date(),
                refId: lead.leadId

              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {

                if (isEditCall) {

                  onAddEmailLog(values)
                  //onAddLeadNote(updateData);
                } else {

                }
                this.toggleEmailLog();
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent" onChange={handleChange} />
                          Email Sent
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Email Received" onChange={handleChange} />
                          Email Received
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced" onChange={handleChange} />
                          Email Bounced
                        </label>

                      </div>
                      <ErrorMessage
                        name="actionType"
                        component="div"
                        className="invalid-feedback"
                      />
                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addedDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.addedDate && touched.addedDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.addedDate}
                          onChange={(value) => setFieldValue('addedDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="addedDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="remarks">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="remarks"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="remarks"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Email Log History</div>
            <ul className="verti-timeline list-unstyled">

              {map(emaillogs, (emailLog, emailkey) => (

                <li className="event-list eventlist" key={"_email_" + emailkey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D-MMM-YYYY">{emailLog.addedDate}</Moment>

                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                    </div>
                  </div>
                  <div className="exNote">{emailLog.activityRemarks}</div>
                </li>
              ))}

            </ul>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isSmsLog}
          direction="end"
          toggle={this.toggleSmsLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleSmsLogCanvas}>
            SMS Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                logDate: new Date(),


              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={this.handleLeadEmailSubmit}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="SMS Sent" onChange={handleChange} />
                          SMS Sent
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Received" onChange={handleChange} />
                          SMS Received
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Bounced" onChange={handleChange} />
                          SMS Bounced
                        </label>

                      </div>

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="logDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.logDate && touched.logDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.logDate}
                          onChange={(value) => setFieldValue('logDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="logDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="smsNote">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="smsNote"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="smsNote"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isAddLead}
          direction="end"
          toggle={this.toggleAddLeadCanvas}

        >
          <OffcanvasHeader toggle={this.toggleAddLeadCanvas}>
            Add New Prospect
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                projectCampaignId: projectData.id,
                projectCampaignGuid: this.props.match.params.projectId,
                campaignProjectGuid: this.props.match.params.projectId,
                firstName: (this.state && this.state.firstName) || "",
                lastName: (this.state && this.state.lastName) || "",
                phone: (this.state && this.state.phone) || "",
                mobile: (this.state && this.state.mobile) || "",
                email: (this.state && this.state.email) || "",
                fullAddress: ''


              }}
              validationSchema={Yup.object().shape({
                firstName: Yup.string().required("This is required"),
                lastName: Yup.string().required("This is required"),
                phone: Yup.string().matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'Enter number is not valid'),
                mobile: Yup.string().required('This is required'),
                email: Yup.string().email('Enter Valid Email').required('This is required')

              })}

              onSubmit={this.handleProjectCampLeadSubmit}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="firstName">
                          {this.props.t("First Name *")}
                        </Label>
                        <SafeField
                          name="firstName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.firstName && touched.firstName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="lastName">
                          {this.props.t("Last Name *")}
                        </Label>
                        <SafeField
                          name="lastName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.lastName && touched.lastName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="phone">
                          {this.props.t("Phone")}
                        </Label>
                        <SafeField
                          name="phone"
                          render={({ field }) => (
                            <MaskedInput
                              {...field}
                              mask={phoneNumberMask}
                              id="phone"
                              placeholder=""
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={
                                "form-control" +
                                (errors.phone && touched.phone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                          )}
                        />
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="mobile">
                          {this.props.t("Mobile *")}
                        </Label>
                        <SafeField
                          name="mobile"
                          className={
                            "form-control" +
                            (errors.mobile && touched.mobile
                              ? " is-invalid"
                              : "")
                          }
                          id="mobile"
                          placeholder=""
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}

                        />
                        <ErrorMessage
                          name="mobile"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="email">
                          {this.props.t("Email *")}
                        </Label>
                        <SafeField
                          name="email"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.email && touched.email
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="fullAddress">
                          {this.props.t("Address")}
                        </Label>


                        <PlacesAutocomplete
                          value={values.fullAddress}
                          onChange={(value) => setFieldValue('fullAddress', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="leadSourceId">
                          {this.props.t("Source")}
                        </Label>
                        <SafeField
                          name="leadSourceId"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.leadSourceId && touched.leadSourceId
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="leadSourceId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="referredBy">
                          {this.props.t("Referred By")}
                        </Label>
                        <SafeField
                          name="referredBy"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.referredBy && touched.referredBy
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="referredBy"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isWorkSheet}
          direction="end"
          toggle={this.toggleSendWorksheet}

        >
          <OffcanvasHeader toggle={this.toggleSendWorksheet}>
            Send Worksheet
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                //subject:'',
                projectCampaignLeadId: camplead.alllists,
                campaignProjectId: projectData.id,
                campaignProjectGuid: this.props.match.params.projectId,
                agentId: parseInt(localStorage.getItem("userId")),
                worksheetSubject: 'Worksheet submission for ' + projectData.projectName,
                worksheetNotes: '<p>As discussed, find the link  to submit the worksheet for the ' + projectData.projectName + '<br /> Do fill in all the form and attach verfication documents\
                <br /> Thanks <br /> '+ agentEMail + '</p>'


              }}
              validationSchema={Yup.object().shape({
                worksheetSubject: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {
                
                if (isSendWorksheetEmail) {
                  //
                  onSendWorksheetEmailLog(values)
                } else {

                }
                this.toggleWorkSheet();
              }}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <h4><small>{trueCount} Record Selected</small></h4>
                    </Col>
                    <Col md="12">
                      <h4><small>Worksheet link worksheets.realtyspacehub.com/agent/clientName</small></h4>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="worksheetSubject">
                          {this.props.t("Subject")}
                        </Label>
                        <SafeField
                          name="worksheetSubject"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.worksheetSubject && touched.worksheetSubject
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="worksheetSubject"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>





                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="worksheetNotes">
                          {this.props.t("Email Content")}
                        </Label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={values.worksheetNotes}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setFieldValue('worksheetNotes', data);
                          }}
                        />
                        <ErrorMessage
                          name="worksheetNotes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isMessage}
          direction="end"
          toggle={this.toggleMessageCanvas}
        >
          <OffcanvasHeader toggle={this.toggleMessageCanvas}>
            Message
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{

                //refId: lead.leadId,
                addMessage: (this.state && this.state.addMessage) || "",



              }}
              validationSchema={Yup.object().shape({
                addMessage: Yup.string().required("This is Required")
              })}

              onSubmit=""
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addNote">
                          {this.props.t("Send Message")}
                        </Label>
                        <textarea
                          name="addMessage"
                          onChange={handleChange}
                          type="textarea"
                          className={
                            "form-control" +
                            (errors.addMessage && touched.addMessage
                              ? " is-invalid"
                              : "")
                          }
                          id="addMessage"
                        />
                        <ErrorMessage
                          name="addMessage"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                </Form>
              )}
            </Formik>
            <div className="mb-5 h4 card-title mt-20">Message History</div>

          </OffcanvasBody>
        </Offcanvas>
        <Offcanvas
          isOpen={this.state.isSubmittedData}
          direction="end"
          toggle={this.toggleSubmittedCanvas}
          style={{ width: 600 }}

        >
          <OffcanvasHeader className="submittedWorksheet" toggle={this.toggleSubmittedCanvas}>
            Submitted Worksheet <span className="float-end"><i className=" bx bx-printer"></i></span>
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "1",
                  })}
                  onClick={() => {
                    this.toggle1("1");
                  }}
                >
                  Applicant Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "2",
                  })}
                  onClick={() => {
                    this.toggle1("2");
                  }}
                >
                  Unit Choices
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "4",
                  })}
                  onClick={() => {
                    this.toggle1("4");
                  }}
                >
                  Unit Status
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "3",
                  })}
                  onClick={() => {
                    this.toggle1("3");
                  }}
                >
                  Documents
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent
              activeTab={this.state.activeTab1}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  {map(worksheetPurData, (purData, purkey) => (
                    <>
                      <h5>Purchaser {purkey + 1}</h5>
                      <div className="table-responsive">
                        <Table className="table table-sm m-0">

                          <tbody>
                            <tr>
                              <th scope="row">Name</th>
                              <td>{purData.firstName + " " + purData.lastName}</td>

                            </tr>
                            <tr>
                              <th scope="row">Address</th>
                              <td>{purData.address}</td>
                            </tr>
                            <tr>
                              <th scope="row">City</th>
                              <td>{purData.city}</td>

                            </tr>
                            <tr>
                              <th scope="row">Province</th>
                              <td>{purData.province}</td>

                            </tr>
                            <tr>
                              <th scope="row">Phone</th>
                              <td>{purData.homePhone}</td>

                            </tr>
                            <tr>
                              <th scope="row">Cell</th>
                              <td>{purData.cellPhone}</td>
                            </tr>
                            <tr>
                              <th scope="row">Email</th>
                              <td>{purData.email}</td>

                            </tr>
                            <tr>
                              <th scope="row">Birth Date</th>
                              <td>{purData.birthDate ? <Moment format="D-MMM-YYYY">{purData.birthDate}</Moment> : ''}</td>
                            </tr>
                            <tr>
                              <th scope="row">Drivers License</th>
                              <td>{purData.driversLicense}</td>

                            </tr>
                            <tr>
                              <th scope="row">Occupation</th>
                              <td>{purData.occupation}</td>
                            </tr>

                          </tbody>
                        </Table>
                      </div>
                      <p>{" "}</p>
                    </>
                  ))}
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="tabContent">
                  <div className="table-responsive">
                    <Table className="table table-sm m-0">

                      <tbody>
                        {map(worksheetUnitData, (unitData, unitkey) => (
                          <>
                            <tr>
                              <th scope="row">Choice {unitkey + 1}</th>
                              <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>


                            </tr>
                            <tr>
                              <td colSpan="2">Notes: {unitData.optionNotes}</td>
                            </tr>
                          </>
                        ))}


                      </tbody>
                    </Table>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="tabContent">
                  <div className="table-responsive">


                    <h5>Purchaser</h5>
                    <Table className="table table-sm m-0">

                      <tbody>
                        {map(worksheetDocData, (docData, dockey) => (
                          <tr>
                            <th scope="row">{dockey + 1}</th>
                            <td>{docData.documentTitle}</td>
                            <td><a target="_blank" rel="noreferrer" href={docData.documentURL}>View</a></td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <p>{" "}</p>



                  </div>
                </div>
              </TabPane>
              <TabPane tabId="4">
                <TabPane tabId="4">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        check_email: false,
                        payment_deposite: false,
                        projectAdditionalFeatureDescription: '',

                      }}
                      validationSchema={Yup.object().shape({
                        createProjectLeadWorkSheetAllocationList: Yup.array().of(
                          Yup.object().shape({

                          })
                        )

                      })}

                      onSubmit=""
                    >

                      {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>

                            <Col md="12">
                              <FormGroup className="mb-3">


                                <Input
                                  type="radio"
                                  id="customRadioInline1"
                                  name="unitStatusId"
                                  className="form-check-input mt-2"
                                  value="1"
                                  checked={values.unitStatusId === 1}
                                  onChange={(e) => {
                                    setFieldValue('unitStatusId', 1);
                                    setFieldValue('unitStatusText', 'Waiting for allocation');
                                  }}
                                />
                                <Label
                                  className="form-check-label ms-4"
                                  htmlFor="customRadioInline1"
                                >
                                  <span className="">Waiting for allocation</span>
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">


                                <Input
                                  type="radio"
                                  id="customRadioInline2"
                                  name="unitStatusId"
                                  className="form-check-input mt-2"
                                  value="2"
                                  checked={values.unitStatusId === 2}
                                  onChange={(e) => {
                                    setFieldValue('unitStatusId', 2);
                                    setFieldValue('unitStatusText', 'Unit Not allocated');
                                  }}
                                />
                                <Label
                                  className="form-check-label ms-4"
                                  htmlFor="customRadioInline2"
                                >
                                  <span className="">Unit Not allocated</span>
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">


                                <Input
                                  type="radio"
                                  id="customRadioInline3"
                                  name="unitStatusId"
                                  className="form-check-input mt-2"
                                  value="3"
                                  checked={values.unitStatusId === 3}
                                  onChange={(e) => {
                                    setFieldValue('unitStatusId', 3);
                                    setFieldValue('unitStatusText', 'Unit Allocated');
                                  }}
                                />
                                <Label
                                  className="form-check-label ms-4"
                                  htmlFor="customRadioInline3"
                                >
                                  <span className="">Unit Allocated</span>
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              <FormGroup className="mb-3">


                                <Input
                                  type="radio"
                                  id="customRadioInline4"
                                  name="unitStatusId"
                                  className="form-check-input mt-2"
                                  value="4"
                                  checked={values.unitStatusId === 4}
                                  onChange={(e) => {
                                    setFieldValue('unitStatusId', 4);
                                    setFieldValue('unitStatusText', 'Withdrawn from client');
                                  }}
                                />
                                <Label
                                  className="form-check-label ms-4"
                                  htmlFor="customRadioInline4"
                                >
                                  Withdrawn from client
                                </Label>
                              </FormGroup>
                            </Col>
                          </Row>
                          {values.unitStatusId !== 1 && (
                            <>
                              <hr></hr>
                              {values.unitStatusId !== 2 && values.unitStatusId !== 4 && (
                                <>
                                  <div id="Selchoice">
                                    <FieldArray name="createProjectLeadWorkSheetAllocationList">
                                      {({ insert, remove, push }) => (
                                        <>
                                          {map(worksheetUnitData, (unitData, unitkey) => (
                                            <Row key={unitkey}>
                                              <Col md="12">
                                                <div className="form-check mb-3">
                                                  <SafeField
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`}
                                                    //value={unitData.id}
                                                    id={`defaultCheck${unitkey}`}
                                                    onChange={(e) => {
                                                      const isChecked = e.target.checked;
                                                      const newValue = isChecked ? unitData.id : null;
                                                      const optionText = isChecked ? `${unitData.optionNumber}/${unitData.optionType}` : '';

                                                      setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionId`, newValue);
                                                      setFieldValue(`createProjectLeadWorkSheetAllocationList.${unitkey}.selectedOptionText`, optionText);
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    id={`defaultCheck${unitkey}`}
                                                  >
                                                    {unitData.optionNumber}/{unitData.optionType}
                                                  </label>
                                                </div>

                                              </Col>
                                              <Col md="4">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}>
                                                    {this.props.t("Inside sq. ft.")}
                                                  </Label>
                                                  <SafeField
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                    type="text"
                                                    className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt &&
                                                      touched.createProjectLeadWorkSheetAllocationList &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey].insideSqFt
                                                      ? " is-invalid"
                                                      : ""
                                                      }`}
                                                  />
                                                  <ErrorMessage
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.insideSqFt`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md="4">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}>
                                                    {this.props.t("Outside sq.ft")}
                                                  </Label>
                                                  <SafeField
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt &&
                                                      touched.createProjectLeadWorkSheetAllocationList &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey].outsideSqFt
                                                      ? " is-invalid"
                                                      : ""
                                                      }`}
                                                  />
                                                  <ErrorMessage
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.outsideSqFt`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md="4">
                                                <FormGroup className="mb-3">
                                                  <Label htmlFor={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}>
                                                    {this.props.t("Cost")}
                                                  </Label>
                                                  <SafeField
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                    type="text"
                                                    onChange={handleChange}
                                                    className={`form-control${errors.createProjectLeadWorkSheetAllocationList &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      errors.createProjectLeadWorkSheetAllocationList[unitkey].unitCost &&
                                                      touched.createProjectLeadWorkSheetAllocationList &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey] &&
                                                      touched.createProjectLeadWorkSheetAllocationList[unitkey].unitCost
                                                      ? " is-invalid"
                                                      : ""
                                                      }`}
                                                  />
                                                  <ErrorMessage
                                                    name={`createProjectLeadWorkSheetAllocationList.${unitkey}.unitCost`}
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </FormGroup>
                                              </Col>
                                            </Row>


                                          ))}
                                        </>
                                      )}
                                    </FieldArray>
                                  </div>

                                </>
                              )}

                              <Row id="noteRow">
                                <Col md="12">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="unitNote">
                                      {this.props.t("Add Note")}
                                    </Label>
                                    <SafeField
                                      name="unitNote"
                                      onChange={handleChange}
                                      as="textarea"
                                      className={
                                        "form-control" +
                                        (errors.unitNote && touched.unitNote
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="unitNote"
                                    />
                                    <ErrorMessage
                                      name="unitNote"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                          )}

                        </Form>
                      )}
                    </Formik>


                  </div>
                </TabPane>
              </TabPane>
            </TabContent>

          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment >
    )
  }
}

projectTransferred.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  className: PropTypes.any,
  addProjectCampLead: PropTypes.func,
  loading: PropTypes.object,
  onGetProjectCampLead: PropTypes.func,
  campleads: PropTypes.array,
  onDeleteCampLead: PropTypes.func,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  leadNotes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetAllProjectOpenHouse: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  leadNotes: PropTypes.array,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onSendWorksheetEmailLog: PropTypes.func,
  onGetProjectSettingWorksheet: PropTypes.func,
  worksheets: PropTypes.array,
  allProjectOpenHouseData: PropTypes.array,
  addProjectOpenHouse: PropTypes.func,
  updateProjectOpenHouse: PropTypes.func,
  deleteProjectOpenHouse: PropTypes.func,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onGetProjectWorksheetLeadPurDetail: PropTypes.func,
  onGetProjectWorksheetLeadUnitDetail: PropTypes.func,
  onGetProjectWorksheetLeadDocDetail: PropTypes.func,
  onGetProjectWorksheetUnitinfo: PropTypes.func,
  worksheetPurData: PropTypes.array,
  worksheetUnitData: PropTypes.array,
  worksheetDocData: PropTypes.array,
}
const mapStateToProps = ({ Project, leads }) => (

  {
    projectData: Project.projectData,
    loading: Project.loading,
    campleads: Project.campleads,
    leadNotes: leads.leadNotes,
    leadFollows: leads.leadFollows,
    calllogs: leads.calllogs,
    emaillogs: leads.emaillogs,
    worksheets: Project.worksheets,
    allProjectOpenHouseData: Project.allProjectOpenHouseData,
    activities: leads.activities,
    worksheetPurData: Project.worksheetPurData,
    worksheetUnitData: Project.worksheetUnitData,
    worksheetDocData: Project.worksheetDocData,
  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectCampLead: (data) => dispatch(addProjectCampLead(data)),
  onGetProjectCampLead: (agentId, projectId) => dispatch(getProjectCampLead(agentId, projectId)),
  onDeleteCampLead: (id) => dispatch(deleteProjectCampLead(id)),
  onAddLeadNote: (data) => dispatch(addLeadNoteTab(data)),
  onGetNoteLead: (leadId) => dispatch(getNoteLeadTab(leadId)),
  onGetFollowLead: (leadId) => dispatch(getFollowLeadTab(leadId)),
  onAddLeadFollowUp: (data) => dispatch(addFollowNoteTab(data)),
  onAddCallLog: (data) => dispatch(addLeadCallLog(data)),
  onGetLeadCallLog: (leadId) => dispatch(getLeadCallLog(leadId)),
  onAddEmailLog: (data) => dispatch(addLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId) => dispatch(getLeadEmailLog(leadId)),
  onSendWorksheetEmailLog: (data) => dispatch(sendProjectLeadWorksheet(data)),
  onGetProjectSettingWorksheet: (projectId) => dispatch(getProjectSettingWorksheet(projectId)),
  onGetAllProjectOpenHouse: (agentId, projectId) => dispatch(getAllProjectOpenHouse(agentId, projectId)),
  addProjectOpenHouse: (data) => dispatch(addProjectOpenHouse(data)),
  updateProjectOpenHouse: (data) => dispatch(updateProjectOpenHouse(data)),
  deleteProjectOpenHouse: (id) => dispatch(deleteProjectOpenHouse(id)),
  onGetAllActLead: (leadId) => dispatch(getAllActLeadTab(leadId)),
  onGetProjectWorksheetLeadPurDetail: (id) => dispatch(getProjectWorksheetLeadPurDetail(id)),
  onGetProjectWorksheetLeadUnitDetail: (id) => dispatch(getProjectWorksheetLeadUnitDetail(id)),
  onGetProjectWorksheetLeadDocDetail: (id) => dispatch(getProjectWorksheetLeadDocDetail(id)),
  onGetProjectWorksheetUnitinfo: (id) => dispatch(getProjectWorksheetUnitinfo(id)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectTransferred)))
